export default class HomeFiltersModel {
    visibilityCompsetId: string | null = null;
    visibilityProvider: string | null = null;
    ratesProvider: string | null = null;
    ratesPos: string | null = null;
}
